import { styled } from '@mui/material';
import { forwardRef } from 'react';
import {
    Add,
    AddPhoto,
    AI,
    Announcement,
    ArrowDown,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    Attach,
    Avatar,
    Bell,
    BellOff,
    Bold,
    BookmarkFilled,
    BookmarkOutlined,
    Calendar,
    Call,
    CallDisabled,
    CallIncoming,
    CallOutgoing,
    Canada,
    Channel,
    Checkmark,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Clock,
    Code,
    Column,
    Copy,
    Dashboard,
    Delete,
    Download,
    DropdownArrowDown,
    DropdownArrowUp,
    Edit,
    Email,
    Ensightful,
    Error as ErrorIcon,
    Exam,
    Exit,
    FavoriteEmpty,
    FavoriteFilled,
    FileCSV,
    FileExcel,
    FileHTML,
    FileImg,
    FilePDF,
    FilePPT,
    FileTypeDoc,
    FileTypeGif,
    FileTypeJpg,
    FileTypePdf,
    FileTypePng,
    FileTypeSvg,
    FileTypeTxt,
    FileTypeUndefined,
    FileTypeVideo,
    FileTypeZip,
    FileUnknown,
    FileUploaded,
    FileWord,
    FileZIP,
    Filter,
    Folder,
    FormatDeselected,
    FormatSelected,
    FullScreenEnter,
    FullScreenExit,
    Google,
    GradientSparkle,
    GraphBarEmpty,
    GraphPieEmpty,
    GraphPieFilled,
    Hamburger,
    Hashtag,
    Help,
    Hide,
    Home,
    Hugo,
    Info,
    Italic,
    Link,
    ListOrdered,
    ListUnordered,
    LocationEmpty,
    LocationFilled,
    Lock,
    Logout,
    Mentions,
    Message,
    MessageFilled,
    MessageRectangular,
    MessageSparkle,
    Mic,
    MoreHorizontal,
    Move,
    NewComment,
    PageJumpLeft,
    PageJumpRight,
    Pause,
    Photo,
    Play,
    Presentation,
    Preview,
    Randomize,
    Refresh,
    Remove,
    Reorder,
    Reply,
    Resync,
    Rocket,
    Save,
    Search,
    Send,
    Settings,
    Sidebar,
    Smile,
    Sort,
    SoundMuted,
    Spreadsheet,
    StarEmpty,
    StarFilled,
    StopWatch,
    Subtask,
    Subtract,
    Task,
    TaskBoard,
    Teams,
    TextAlignLeft,
    TextAlignRight,
    ThumbsDown,
    ThumbsUp,
    TiltedSend,
    Timeline,
    Underline,
    Unlock,
    Upload,
    USA,
    Video,
    Visible,
    Web,
    Wrench,
    ZoomIn,
    ZoomOut,
} from 'shell/icons';

const icons = {
    add: Add,
    addPhoto: AddPhoto,
    ai: AI,
    announcement: Announcement,
    arrowDown: ArrowDown,
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    arrowUp: ArrowUp,
    attach: Attach,
    avatar: Avatar,
    bell: Bell,
    bellOff: BellOff,
    bold: Bold,
    bookmarkFilled: BookmarkFilled,
    bookmarkOutlined: BookmarkOutlined,
    calendar: Calendar,
    call: Call,
    callDisabled: CallDisabled,
    callIncoming: CallIncoming,
    callOutgoing: CallOutgoing,
    canada: Canada,
    channel: Channel,
    checkmark: Checkmark,
    chevronDown: ChevronDown,
    chevronLeft: ChevronLeft,
    chevronRight: ChevronRight,
    chevronUp: ChevronUp,
    clock: Clock,
    code: Code,
    column: Column,
    copy: Copy,
    dashboard: Dashboard,
    delete: Delete,
    download: Download,
    dropdownArrowDown: DropdownArrowDown,
    dropdownArrowUp: DropdownArrowUp,
    edit: Edit,
    email: Email,
    ensightful: Ensightful,
    error: ErrorIcon,
    exam: Exam,
    exit: Exit,
    favoriteEmpty: FavoriteEmpty,
    favoriteFilled: FavoriteFilled,
    fileCSV: FileCSV,
    fileExcel: FileExcel,
    fileHTML: FileHTML,
    fileImg: FileImg,
    filePDF: FilePDF,
    filePPT: FilePPT,
    fileTypeDoc: FileTypeDoc,
    fileTypeGif: FileTypeGif,
    fileTypeJpg: FileTypeJpg,
    fileTypePdf: FileTypePdf,
    fileTypePng: FileTypePng,
    fileTypeSvg: FileTypeSvg,
    fileTypeTxt: FileTypeTxt,
    fileTypeUndefined: FileTypeUndefined,
    fileTypeVideo: FileTypeVideo,
    fileTypeZip: FileTypeZip,
    fileUnknown: FileUnknown,
    fileUploaded: FileUploaded,
    fileWord: FileWord,
    fileZIP: FileZIP,
    filter: Filter,
    folder: Folder,
    formatSelected: FormatSelected,
    formatDeselected: FormatDeselected,
    fullScreenEnter: FullScreenEnter,
    fullScreenExit: FullScreenExit,
    google: Google,
    gradientSparkle: GradientSparkle,
    graphBarEmpty: GraphBarEmpty,
    graphPieEmpty: GraphPieEmpty,
    graphPieFilled: GraphPieFilled,
    hamburger: Hamburger,
    hashtag: Hashtag,
    help: Help,
    hide: Hide,
    home: Home,
    hugo: Hugo,
    info: Info,
    italic: Italic,
    link: Link,
    listOrdered: ListOrdered,
    listUnordered: ListUnordered,
    locationEmpty: LocationEmpty,
    locationFilled: LocationFilled,
    lock: Lock,
    logout: Logout,
    mentions: Mentions,
    message: Message,
    messageFilled: MessageFilled,
    messageRectangular: MessageRectangular,
    messageSparkle: MessageSparkle,
    mic: Mic,
    moreHorizontal: MoreHorizontal,
    move: Move,
    newComment: NewComment,
    pageJumpLeft: PageJumpLeft,
    pageJumpRight: PageJumpRight,
    pause: Pause,
    photo: Photo,
    play: Play,
    presentation: Presentation,
    preview: Preview,
    randomize: Randomize,
    refresh: Refresh,
    remove: Remove,
    reorder: Reorder,
    reply: Reply,
    resync: Resync,
    rocket: Rocket,
    save: Save,
    search: Search,
    send: Send,
    settings: Settings,
    sidebar: Sidebar,
    smile: Smile,
    sort: Sort,
    soundMuted: SoundMuted,
    spreadsheet: Spreadsheet,
    starEmpty: StarEmpty,
    starFilled: StarFilled,
    stopWatch: StopWatch,
    subtask: Subtask,
    subtract: Subtract,
    task: Task,
    taskBoard: TaskBoard,
    teams: Teams,
    textAlignLeft: TextAlignLeft,
    textAlignRight: TextAlignRight,
    thumbsDown: ThumbsDown,
    thumbsUp: ThumbsUp,
    tiltedSend: TiltedSend,
    timeline: Timeline,
    underline: Underline,
    unlock: Unlock,
    upload: Upload,
    usa: USA,
    video: Video,
    visible: Visible,
    web: Web,
    wrench: Wrench,
    zoomIn: ZoomIn,
    zoomOut: ZoomOut,
};

const KINDS = Object.keys(icons);

const Icon = forwardRef(({ kind, ...rest }, ref) => {
    const IconComponent = icons[kind];
    return <IconComponent ref={ref} {...rest} />;
});

const CustomIcon = styled(Icon)(() => {
    return {
        fontSize: '1rem',
    };
});

export default forwardRef((props, ref) => {
    if (!KINDS.includes(props.kind)) throw new Error(`Shell: Invalid kind "${props.kind}" in component Icon.`);

    return <CustomIcon ref={ref} {...props} />;
});
